import React, { useState, useEffect } from 'react';
import {
  BookOpen,
  FileText,
  Monitor,
  GraduationCap,
  Award,
  Users,
  Library,
  Calendar
} from 'lucide-react';

const CollegeAtGlance = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /* ---------- RIGHT SIDE CARDS ---------- */
  const resourceCards = [
    { label: 'Books Chapter', icon: BookOpen, color: '#660033' },
    { label: 'Journals', icon: FileText, color: '#024621' },
    { label: 'E Resources', icon: Monitor, color: '#FFC543', darkText: true },
    { label: 'E-Class', icon: GraduationCap, color: '#660033' }
  ];

  /* ---------- STYLES ---------- */
  const styles = {
    section: {
      padding: '60px 40px',
      backgroundColor: '#f8f9fa'
    },
    mainGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1.2fr 1fr',
      gap: '32px',
      maxWidth: '1200px',
      margin: '0 auto'
    },

    /* ---------- COLLEGE AT A GLANCE ---------- */
    glanceCard: {
      background: 'linear-gradient(135deg, #ffffff, #f6f6f6)',
      borderRadius: '18px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
      overflow: 'hidden'
    },
    glanceHeader: {
      background: '#024621',
      color: '#fff',
      padding: '20px 24px',
      fontSize: '22px',
      fontWeight: '700'
    },
    glanceBody: {
      padding: '26px',
    maxHeight: '360px',   // 👈 controls when scrollbar appears
    overflowY: 'auto'
    },
    glanceItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '18px',
      fontSize: '15px',
      fontWeight: '500',
      color: '#333'
    },
    glanceIcon: {
      width: '42px',
      height: '42px',
      borderRadius: '50%',
      backgroundColor: '#02462115',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '14px'
    },

    /* ---------- RESOURCE CARDS ---------- */
    cardGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '22px'
    },
    card: (color) => ({
      backgroundColor: color,
      borderRadius: '18px',
      padding: '34px 20px',
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }),
    iconWrapper: {
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255,255,255,0.2)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '18px',
      transition: 'transform 0.3s ease'
    },
    cardLabel: {
      fontSize: '18px',
      fontWeight: '600',
      marginBottom: '14px'
    },
    exploreBtn: {
      padding: '8px 26px',
      borderRadius: '20px',
      border: 'none',
      backgroundColor: 'rgb(255 255 255 / 0.2)',
      fontWeight: '600',
      cursor: 'pointer'
      
    }
  };

  return (
    <div style={styles.section}>
      <div style={styles.mainGrid}>

        {/* ---------- COLLEGE AT A GLANCE ---------- */}
        <div style={styles.glanceCard}>
          <div style={styles.glanceHeader}>College at a Glance</div>
          <div style={styles.glanceBody}>
            <div style={styles.glanceItem}>
              <div style={styles.glanceIcon}><Award size={20} /></div>
              NAAC Accredited B+ Grade (3rd Cycle)
            </div>
            <div style={styles.glanceItem}>
              <div style={styles.glanceIcon}><Library size={20} /></div>
              10+ Undergraduate & Postgraduate Programs
            </div>
            <div style={styles.glanceItem}>
              <div style={styles.glanceIcon}><Users size={20} /></div>
              3000+ Students Enrolled
            </div>
            <div style={styles.glanceItem}>
              <div style={styles.glanceIcon}><Calendar size={20} /></div>
              Established in 1963 – 63+ Years of Excellence
            </div>
          </div>
        </div>

        {/* ---------- RESOURCE CARDS ---------- */}
        <div style={styles.cardGrid}>
          {resourceCards.map((card, index) => {
            const Icon = card.icon;
            return (
              <div
                key={index}
                style={{
                  ...styles.card(card.color),
                  color: card.darkText ? '#333' : '#fff'
                }}
                className="resource-card"
                onMouseEnter={(e) => {
                  e.currentTarget.querySelector('.iconWrap').style.transform =
                    'scale(1.1)';
                  e.currentTarget.style.transform = 'translateY(-6px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.querySelector('.iconWrap').style.transform =
                    'scale(1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={styles.iconWrapper} className="iconWrap">
                  <Icon size={40} strokeWidth={1.6} />
                </div>
                <div style={styles.cardLabel}>{card.label}</div>
                <button style={styles.exploreBtn}>Explore</button>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default CollegeAtGlance;
